export default ({ $axios }) => ({
  updateClient: async client => {
    try {
      await $axios.post('/v3/app/portfolio/update-clients', {
        clients: [client],
      })
    } catch (error) {
      console.error('Error updating client', error)
      throw error
    }
  },
  verifyClientPhone: async payload => {
    try {
      await $axios.post('/v3/app/portfolio/phone/verify', {
        code: payload.code,
        comercialDivision: payload.comercialDivision,
        phone: payload.phone,
        phone2: payload.phone2
      })
    } catch (error) {
      console.error('Error verifing client phone', error)
      throw error
    }
  },
  getPortfolio: async () => {
    try {
      const { data } = await $axios.get(`/v3/app/portfolio`)
      return data
    } catch (error) {
      console.error('Error fetching user portfolio', error)
      throw error
    }
  },
  fetchClientCategories: async () => {
    try {
      const { data } = await $axios.get('/v3/app/clientCategory')
      return data
    } catch (error) {
      console.error('Error fetching client categories', error)
      throw error
    }
  },
})
